"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// Geo Redirection in Nav / Menu
(0, _jquery2.default)("#geo-redirect-select").on("change", function () {
  var desURL = (0, _jquery2.default)(this).val() == "peso" ? "https://ph.sunniesstudios.com/?r=php" : "https://sunniesstudios.com/?r=usd";

  (0, _jquery2.default)(this).toggleClass("currency-php currency-usd");

  // Head to designated store
  window.open(desURL, "_parent");
});

// set the width of the currency selector
(0, _jquery2.default)(window).on("resize load", function () {
  var setWidth = (0, _jquery2.default)(this).outerWidth() >= 1024 ? (0, _jquery2.default)(".footer__aside-cols div:last-of-type").outerWidth() : "auto";
  (0, _jquery2.default)(".currency-container").css("width", setWidth);
});

// set mobile layout
(0, _jquery2.default)(window).on("load", function () {
  var currWidth = (0, _jquery2.default)(this).outerWidth();

  if (currWidth <= 767) {
    (0, _jquery2.default)(".secondary-col, .footer__aside-col .menu__item--has-dropdown").on("click", function () {
      (0, _jquery2.default)(this).toggleClass("open").find("ul").slideToggle();
    });
  }
});